import React, {useState, useEffect, useContext, useReducer} from 'react';
import moment from 'moment';
import {scheduleReducer, auditReducer} from '../Utils/reducer.js';
import {useAlert, TYPES} from 'hooks/use-alert-hook.js';
import {Link, useParams, useHistory} from 'react-router-dom';
import AuditContext from '../Utils/context.js';
import {useLocalStorage} from 'react-use';
import {Button, Row, Col, Card, Dropdown, DropdownButton, Form} from 'react-bootstrap';
import axios from 'axios';
import {
  CustomPaging,
  PagingState,
  SortingState,
  IntegratedSorting,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  PagingPanel,
  Table,
  TableHeaderRow,
  TableColumnResizing,
} from '@devexpress/dx-react-grid-bootstrap4';
import { Loading } from 'components/Loading/loading';

const SORT_FIELD_MAP = {};

export default function Finding() {

  const {employeeId} = useParams();
  const {schedule} = useContext(AuditContext);
  // const [schedule, dispatchSchedule] = useReducer(scheduleReducer, null);
  const [auth] = useLocalStorage('authenticated');

  const [countOpen, setCountOpen] = useState(0);
  const [countComplete, setCountComplete] = useState(0);
  const [countProgress, setCountProgress] = useState(0);
  const [statusAction, setStatusAction] = useState('');

  const history = useHistory();
  const [swal, setSwal] = useAlert();
  const [schedules, setSchedules] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [pageSizes] = useState([5, 10, 15]);
  const [columns] = useState([
    {name: 'ACTIONS', title: 'Action', getCellValue: row => {

      let variant = `primary`, label = `Open`;
      switch (row.ANSWER_ACTION_STATUS) {
        case 'COMPLETED':
          variant = `success`;
          label = row?.COMPLETED_AT ? moment(row.COMPLETED_AT, 'DD-MMM-YYYY').format('DD MMM YYYY') : ``;
          break;
        case `IN PROGRESS`:
          variant = `warning`;
          label =  'In Progress';
      }

      return (
        <Link to={`/auditor/${employeeId}/actions/${row.ANSWER_ACTION_ID}/edit`}>
          <Button variant={variant} size="sm">{label}</Button>
        </Link>
      )
    }},
    {name: 'ANSWER_ACTION_ID', title: 'ID', getCellValue: row => row.ANSWER_ACTION_ID},
    {name: 'CRITERIA', title: 'Criteria', getCellValue: row => row?.answer?.form?.criteria.CRITERIA_LABEL ?? `n-a`},
    {name: 'EVALUATE_DESC', title: 'Evaluation', getCellValue: row => row?.answer.EVALUATE_DESC ?? `n-a`},
    {name: 'CAUSE_DESC', title: 'Finding', getCellValue: row => row?.answer.CAUSE_DESC ?? `n-a`},
    {name: 'TYPE', title: 'Type', getCellValue: row => row?.actionType.ACTION_TYPE_NAME ?? `n-a`},
    // {name: 'ACTION_PLAN', title: 'Action Plan', getCellValue: row => row.PLAN_DESC ?? `n-a`},
    {name: 'DUE_DATE', title: 'Due Date', getCellValue: row => moment(row.DUE_DATE, 'DD-MMM-YYYY').format(`DD MMM YYYY`) ?? `n-a`},
    {name: 'PIC', title: `PIC`, getCellValue: row => row?.pics?.map(pic => pic?.employee?.EMP_NAME).join(`, `)},

  ]);
  const [defaultColumnWidths] = useState([
    {columnName: 'ACTIONS', width: 100 },
    { columnName: 'ANSWER_ACTION_ID', width: 60 },
    { columnName: 'CRITERIA', width: 200 },
    {columnName: 'EVALUATE_DESC', width: 180 },
    {columnName: 'CAUSE_DESC', width: 180 },
    {columnName: 'TYPE', width: 180 },
    // {columnName: 'ACTION_PLAN', width: 180 },
    {columnName: 'DUE_DATE', width: 180 },
    {columnName: 'PIC', width: 180 },
    {columnName: 'STATUS', width: 180 },
  ]);
  const [columnWidths, setColumnWidths] = useState(defaultColumnWidths);
  const [loading, setLoading] = useState(false);
  const [sorting, setSorting] = useState([{ columnName: 'ANSWER_ACTION_ID', direction: 'asc' }]);

  const [rows, setRows] = useState([]);

  const [rowschedule, setRowschedule] = useState([]);

  const getRowId = row => row.ANSWER_ACTION_ID;

  const [type, setType] = useState(schedule.SCHEDULE_ID);
  const [year, setYear] = useState(schedule.START_DATE);

  const fetchAnswerActions = async () => {

    setLoading(true);
    fetchCountingAnswerActions();
    try {

      const orderBy = sorting?.[0];
      const response = await axios.get(`${process.env.REACT_APP_API_HOST}answer-actions`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: {
          // SCHEDULE_ID: schedule.SCHEDULE_ID,
          SCHEDULE_ID: type,
          expand: `auditee.department,answer.form.criteria,pics.employee,actionType`,
          page: currentPage + 1,
          'per-page': pageSize,
          sort: `${orderBy?.direction === 'desc' ? '-' : ''}${SORT_FIELD_MAP[orderBy?.columnName] ?? orderBy?.columnName}`
        }
      });

      setRows(response.data.items);
      setTotalCount(response.data._meta.totalCount);
      history.push(`/auditor/${auth.employee.EMP_ID}/audits/${type}/findings`);

    } catch (error) {
      console.log(error);
      alert(`error`);
    }

    setLoading(false);
  };

  const fetchSchedules = async () => {

    try {

      setLoading(true);

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}schedules`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: {
          expand: `auditee.department,instrument.standard`,
          sort: `-SCHEDULE_ID`,
          // page: currentPage + 1,
          // 'per-page': pageSize,
          'search': schedule.auditee.department.DEPT_NAME,
          // AUDITOR_TEAMS__EMP_ID: employeeId,
          // sort: `${orderBy?.direction === 'desc' ? '-' : ''}${SORT_FIELD_MAP[orderBy?.columnName] ?? orderBy?.columnName}`
        }
      });
      const newSchedule = [];
      if (response.data._meta.totalCount >= 1){
        let k = 0;
        response.data.items.map((name) => {
          if (name.auditee.department.DEPT_NAME === schedule.auditee.department.DEPT_NAME){
            newSchedule.push(response.data.items[k]);
            k += 1;
          } else {
            k += 1
          }
        })
        setSchedules(newSchedule);
      } else {
        setSchedules(response.data.items);
      }

    } catch (error) {
      alert(error)
    }
  };

  const fetchCountingAnswerActions = async () => {

    try {
      setCountOpen(0)
      setCountProgress(0)
      setCountComplete(0)
      const response = await axios.get(`${process.env.REACT_APP_API_HOST}answer-action/count-status`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: {
          id: type
        }
      });
      response.data.result.forEach(data => {
        if(data.ANSWER_ACTION_STATUS=='OPEN'){
          setCountOpen(data.JUMLAH)
        }else if(data.ANSWER_ACTION_STATUS=='IN PROGRESS'){
          setCountProgress(data.JUMLAH)
        }else if(data.ANSWER_ACTION_STATUS=='COMPLETED'){
          setCountComplete(data.JUMLAH)
        }
      })

    } catch (error) {
      console.log(error);
      alert(`error`);
    }
  };

  const fetchSearchAnswerActions = async () => {

    setLoading(true);

    try {

      const response = await axios.get(`${process.env.REACT_APP_API_HOST}answer-actions`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: {
          SCHEDULE_ID: type,
          expand: `answer.form.criteria,pics.employee,actionType`,
          ANSWER_ACTION_STATUS: statusAction,
        }
      });

      setRows(response.data.items);
      setTotalCount(response.data._meta.totalCount);

    } catch (error) {
      console.log(error);
      alert(`error`);
    }

    setLoading(false);
  };

  useEffect(fetchAnswerActions, [pageSize, currentPage]);
  useEffect(() => {
    fetchSchedules();
    return () => {}
  }, [])

  //useEffect(fetchCountingAnswerActions, [type]);

  return (
    <>
    <Row style={{width:"90%"}}>
      <Col md="7">
        <Card>
          <Card.Header>
            <Card.Title as="h4" className="text-capitalize">Summary of list {moment(schedule.START_DATE).format('YYYY')} Finding</Card.Title>
            <Card.Body>
              <Row>
                <Form.Group as={Col}>
                  <Form.Control className="w-100" defaultValue={-1} name="SCHEDULE_ID" as="select" onChange=
                    {e => {
                      setType(e.target.value);
                    }}
                  >
                    <option value={-1}>Select Years Finding...</option>
                    {schedules && schedules.map((schedules, key) => (
                    <option key={key} value={schedules.SCHEDULE_ID}>
                      {moment(schedules.START_DATE).format('YYYY')+' / '+schedules.instrument.INSTRUMENT_NAME}
                      </option>
                      ))}
                  </Form.Control>
                </Form.Group>
                <Form.Group as={Col}>
                  <Button onClick={fetchAnswerActions}>Generate</Button>
                </Form.Group>
                <Form.Group as={Col}>

                </Form.Group>

              </Row>
            </Card.Body>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col sm={6} md={3} style={{width:'70%'}}>Filter Status : </Col>
              <Col sm={6} md={4}>
                <Form.Group as={Col}>
                  <Form.Control className="w-100" name="STATUS" as="select" onChange={e => {setStatusAction(e.target.value);}}>
                    <option>Select Status...</option>
                    <option value='OPEN'>OPEN</option>
                    <option value='IN PROGRESS'>IN PROGRESS</option>
                    <option value='COMPLETED'>COMPLETED</option>
                    <option value=''>All</option>
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col sm={6} md={4}><Button variant='primary' size="sm" onClick={fetchSearchAnswerActions}>Show</Button></Col>
              <Col sm={6} md={4}>OPEN: {countOpen}</Col>
              <Col sm={6} md={4}>IN PROGRESS: {countProgress}</Col>
              <Col sm={6} md={4}>COMPLETED: {countComplete}</Col>
            </Row>
            <Grid
              rows={rows}
              columns={columns}
              getRowId={getRowId}
            >
              <PagingState
                currentPage={currentPage}
                onCurrentPageChange={setCurrentPage}
                pageSize={pageSize}
                onPageSizeChange={setPageSize}
              />

              <SortingState
                sorting={sorting}
                onSortingChange={setSorting}
              />
              <IntegratedSorting />
              <CustomPaging totalCount={totalCount} />
              <Table />
              <TableColumnResizing
                columnWidths={columnWidths}
                onColumnWidthsChange={setColumnWidths}
              />
              <TableHeaderRow showSortingControls />
              <PagingPanel
                pageSizes={pageSizes}
              />
              {loading && <Loading />}
            </Grid>
          </Card.Body>
        </Card>
      </Col>
    </Row>

    </>
  );
}